import React, { Component } from 'react'
import withSearch from 'containers/withSearch'
import styled from 'styled-components'
import easing from 'ui/styles/easing'
import { Link } from 'react-router-dom'
import getRelativeUrl from 'utils/getRelativeUrl'
import posed, { PoseGroup } from 'react-pose'

// Animation
const PosedContainer = posed.div({
  enter: {
    y: 0,
    opacity: 1,
  },

  exit: {
    y: 50,
    opacity: 0,
  }
})

// Styling
const Arrow = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  background: ${props => props.theme.colors[props.color].light};
  width: 80px;
  height: 50px;
  opacity: 0;
  transition: opacity 0.3s ${easing.easeOutCubic};
  display: flex;
  justify-content: center;
  align-items: center;
`

const Result = styled.div`
  padding: 3rem 0;
  border-bottom: 2px solid ${props => props.theme.colors[props.color].light};
  position: relative;

  &:hover ${Arrow} {
    opacity: 1;
  }
`

const Title = styled.h3`
  font-size: 25px;
  color: ${props => props.theme.colors.grey.lightest};
  font-weight: 600;
  margin-bottom: 0;
`

const Excerpt = styled.p`
  color: ${props => props.theme.colors.grey.lightest};
  width: 80%;
  margin-bottom: 0;
  margin-top: 15px;
`

const NoResults = styled.h3`
  font-size: 25px;
  color: ${props => props.theme.colors.grey.lightest};
  text-align: center;
`

class Results extends Component {
  state = {
    results: []
  }

  prepareResults() {
    let results = []

    const { searchResults } = this.props

    for(let group in searchResults) {
      searchResults[group].nodes.map(node =>
        results.push(node)  
      )
    }

    results.sort((a, b) => {
      return new Date(b.date) - new Date(a.date)
    })

    this.setState({results})
  }

  componentDidUpdate(prevProps) {
    if(prevProps !== this.props) {
      this.prepareResults()
    }
  }
  
  render() {
    const {
      color,
      search,
      toggleSearch
    } = this.props
    
    const { results } = this.state
    
    return(
      <PoseGroup withParent={false}>
        {search && results.length ? results.map(result => {
          console.log(result)
          return(
            <PosedContainer key={result.id}>
              <Link
                to={getRelativeUrl(result.link)}
                key={result.id}
                onClick={() => toggleSearch()}
              >
                <Result color={color}>
                  <Title>{result.title}</Title>
                  {result.modules.length && result.modules[0].text ? (
                    <Excerpt>{result.modules[0].text}</Excerpt>
                  ) : null}
                  <Arrow color={color}>
                    <svg
                      width="18"
                      height="15"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill="#FFF"
                        fillRule="evenodd"
                        d="M10.5610474 14.812003c-.1539376.1484976-.2731487.187997-.4680326.187997h-.8352535c-.349599 0-.4294185-.2414961-.194625-.4679922l6.6330485-6.3986434H.3887311C.1360559 8.1333644 0 8.0021166 0 7.7583707v-.5167414c0-.2437459.1360559-.3749937.3887311-.3749937h15.3074537L9.0631363.4679922C8.8283428.2414961 8.9081623 0 9.2580203 0h.8352535c.194884 0 .3311989.0562491.4677732.187997l7.3073674 7.0491326c.1754475.1692473.1754475.3564943 0 .5257416l-7.3073674 7.0491326 4e-7-8e-7z"
                      />
                    </svg>
                  </Arrow>
                </Result>
              </Link>
            </PosedContainer>
          )
        }) : (
          search && search !== 'Indtast søgeord' &&
            <PosedContainer key="no-results">
              <Result color={color}>
                <NoResults>Ingen resultater fundet...</NoResults>
              </Result>
            </PosedContainer>
        )}
      </PoseGroup>
    )
  }
}

export default withSearch(
  props => ({
    search: props.search
  })
)(Results)




// WEBPACK FOOTER //
// ./src/ui/components/Navigation/Search/Results.js